/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

export const validationMatrix = [
  {
    digest: "valid",
    mdp: "valid",
    certificate: "valid",
    status: "valid",
    messages: ["validSignature"]
  },
  {
    digest: "valid",
    mdp: "valid",
    certificate: "invalid",
    status: "invalid",
    messages: ["invalidSigner"]
  },
  {
    digest: "valid",
    mdp: "valid",
    certificate: "unknown",
    status: "unknown",
    messages: ["unknownSigner"]
  },
  {
    digest: "valid",
    mdp: "invalid",
    certificate: "valid",
    status: "invalid",
    messages: ["invalidModification"]
  },
  {
    digest: "valid",
    mdp: "invalid",
    certificate: "invalid",
    status: "invalid",
    messages: ["invalidModification", "invalidSigner"]
  },
  {
    digest: "valid",
    mdp: "invalid",
    certificate: "unknown",
    status: "invalid",
    messages: ["invalidModification", "unknownSigner"]
  },
  {
    digest: "invalid",
    status: "invalid",
    messages: ["invalidSignature"]
  },
  {
    digest: "unknown",
    status: "unknown",
    messages: ["unsupportedSignature"]
  }
];
